import React from "react";

/**
 * Renders a SendInviteFilledIcon SVG component with the given class name.
 *
 * @param {Object} cls - The class name for styling the SVG component
 * @return {JSX.Element} The rendered SVG component
 */
export const SendInviteFilledIcon = ({ cls }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <path
        d="M20.25 11.6016H18.75V10.1016C18.75 9.68734 18.4142 9.35156 18 9.35156C17.5858 9.35156 17.25 9.68734 17.25 10.1016V11.6016H15.75C15.3358 11.6016 15 11.9373 15 12.3516C15 12.7658 15.3358 13.1015 15.75 13.1015H17.25V14.6016C17.25 15.0158 17.5858 15.3515 18 15.3515C18.4142 15.3515 18.75 15.0158 18.75 14.6016V13.1015H20.25C20.6642 13.1015 21 12.7658 21 12.3516C21 11.9373 20.6642 11.6016 20.25 11.6016Z"
        fill="currentColor"
      />
      <path
        d="M9.5 12.3516C11.9853 12.3516 14 10.3368 14 7.85156C14 5.36628 11.9853 3.35156 9.5 3.35156C7.01472 3.35156 5 5.36628 5 7.85156C5 10.3368 7.01472 12.3516 9.5 12.3516Z"
        fill="currentColor"
      />
      <path
        d="M9.50002 14.3516C5.9118 14.3554 3.00399 17.1738 3 20.6516C3 21.0382 3.32334 21.3516 3.72221 21.3516H15.2778C15.6767 21.3516 16 21.0382 16 20.6516C15.996 17.1738 13.0882 14.3554 9.50002 14.3516Z"
        fill="currentColor"
      />
    </svg>
  );
};
